import { Box, CircularProgress, Paper, Typography } from '@mui/material';
import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

interface LoadingStateProps {
  title?: ReactNode;
  description?: ReactNode;
}

const LoadingState = ({ title, description }: LoadingStateProps) => {
  const { t } = useTranslation();
  const resolvedTitle = title ?? t('visual.loadingState.title');
  const resolvedDescription = description ?? t('visual.loadingState.description');

  return (
    <Paper
      elevation={0}
      sx={theme => ({
        border: `1px solid ${theme.palette.divider}`,
        borderRadius: 4,
        p: 4,
        textAlign: 'center',
        background: theme.customTokens.surfaces.cardGradient,
      })}
    >
      <CircularProgress size={34} />
      <Box sx={{ mt: 2 }}>
        <Typography variant="subtitle1">{resolvedTitle}</Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
          {resolvedDescription}
        </Typography>
      </Box>
    </Paper>
  );
};

export default LoadingState;
